export default __webpack_public_path__ + "static/media/student_mission_1.b1708bcb.png";